import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TabsConstants from "../../../../../constants";
import { grpEditAction, grpUpdateAction } from "../../../../../modules/fieldgroups/action";
import "../../../../../style";
import SubMenu from "../../../SubMenu";
import FieldView from "./Fields/FieldView";
import LoadNoIndicatorView from "./LoadNumberIndicators/LoadNoIndicatorView";


class FieldGroupInfo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activeTabValue: "fields"
    };
  }

  componentWillMount() {
    const path = this.props.route.match.path;
    this.setState({ children: path });
    if (path.includes("field-groups/fields")) {
      this.setState({ activeTabValue: "fields" });
    } else if (path.includes("field-groups/indicators")) {
      this.setState({ activeTabValue: "indicators" });
    }
  }

  componentWillReceiveProps(nextProps) {}

  render() {
    const { activeTabValue, children } = this.state;
    const { FieldGroupInfo } = TabsConstants;
    const menuName = "Field Group";
    return (
      <div className="">
        <SubMenu
          menuName={menuName}
          tabsVisible={FieldGroupInfo}
          routes={this.props.route}
          activeTabValue={activeTabValue}
          handleChangeTabBody={this.updateTabBody}
        />
        {children === "/farmsetup/farminformation/field-groups/fields" && (
          <FieldView />
        )}
        {children === "/farmsetup/farminformation/field-groups/indicators" && (
          <LoadNoIndicatorView />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedGrp: state.fieldGroupReducer.selectedGrp,
    grpUpdated: state.fieldGroupReducer.grpUpdated
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ grpUpdateAction, grpEditAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FieldGroupInfo);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/FieldGroupInfo.js